import React, { useState } from "react";
import { StyleSheet, View } from "react-native";
import { AppartDoorsWithPictures } from "../../../types/types";
import i18n from "../../../i18n";
import { MD3Theme, useTheme } from "react-native-paper";
import Divider from "../../../components/Divider";
import AppButton from "../../../components/AppButton";

import Icon from "react-native-vector-icons/AntDesign";
import Mutations from "../../../api/mutations";
import DoorCardCommonHeader from "./DoorCardCommonHeader";
import { mobUser } from "../../../mobx/MobUser";
import { Text } from "../../../utils/fontsLoader";
import { mobAlert } from "../../../mobx/MobAlert";
import { Platform } from "react-native";

interface DoorCardProps {
  door: AppartDoorsWithPictures;
  idx: number;
}

export default function DoorCardNuki({ door, idx }: DoorCardProps) {
  const [actionInProgress, setActionInProgress] = useState<boolean>(false);

  const mutations = new Mutations();

  const theme = useTheme();
  const styles = styleGen(theme);

  const executeAction = async (
    action: "LOCK" | "UNLOCK",
  ) => {
    mobAlert.closeAlert();
    setActionInProgress(true);
    switch (action) {
    case "LOCK":
      await mobAlert.setLoading(true);
      mutations.closeDoor(mobUser.OiqiaBookingId, door.doorDeviceId).then(async response => {
        await mobAlert.setLoading(false);

        if (response.data?.closeDoor?.success === true) {
          mobAlert.setSuccess(
            i18n.t("generic.success"),
            i18n.t("pages.access.lockSuccess"),
          );
        }

        setActionInProgress(false);
      }).catch(async () => {
        await mobAlert.setLoading(false);
        setActionInProgress(false);
      });

      break;
    case "UNLOCK":
      await mobAlert.setLoading(true);
      mutations.openDoor(mobUser.OiqiaBookingId, door.doorDeviceId).then(async response => {
        await mobAlert.setLoading(false);
        if (response.data?.openDoor?.success === true) {
          mobAlert.setSuccess(
            i18n.t("generic.success"),
            i18n.t("pages.access.unlockSuccess"),
          );
        }
        setActionInProgress(false);
      }).catch(async (e) => {
        console.log("exception UNLOCK", e);
        await mobAlert.setLoading(false);
        setActionInProgress(false);
      });
      break;
    default:
      console.warn("unknown action found at executeAction =>", action);
      break;
    }
  };

  const askConfirmation = (action: "LOCK" | "UNLOCK"): void => {
    mobAlert.setAlert(
      i18n.t("pages.access.confirmActionTitle"),
      i18n.t(`pages.access.confirmActionText${action}`),
      i18n.t("generic.yes"),
      () => executeAction(action),
      i18n.t("generic.no"),
      mobAlert.closeAlert
    );
  };

  return (
    <View>
      <View style={styles.container}>
        <DoorCardCommonHeader idx={idx} digitCode={null} textMultiName={door.textMultiName} textMultiDesc={door.textMultiDesc} doorPictureURL={door.doorPictureURL} />
        <View style={styles.actions}>
          <Text style={styles.actionsTitle}>
            {i18n.t("pages.access.openTitle")}
          </Text>
          <Text style={styles.actionsText}>
            {i18n.t("pages.access.openText")}{" "}
            <Text style={styles.oiqia}>{door.digitCode}</Text>
          </Text>
          <Text style={styles.orText}>
            {i18n.t("generic.or")}
          </Text>
          <AppButton
            extraStyle={styles.extraStyleBtn}
            extraTextStyle={styles.extraStyleBtnText}
            disabled={actionInProgress}
            onPress={() => askConfirmation("UNLOCK")}
          >
            {i18n.t("pages.access.unlock").toUpperCase()}
          </AppButton>
        </View>
        <Divider extraStyle={{ width: "33%" }} />
        <View style={[styles.actions, { marginBottom: 20 }]}>
          <Text style={styles.actionsTitle}>
            {i18n.t("pages.access.closeTitle")}
          </Text>
          <Text style={styles.actionsText}>
            {i18n.t("pages.access.closeText")}{" "}
            {Platform.OS === 'web' ? (
              <Text style={styles.oiqia}>◀️</Text>
            ) : (
              <Icon style={styles.oiqia} name="caretleft" />
            )}{" "}
            {i18n.t("pages.access.closeText2")}
          </Text>
          <Text style={styles.orText}>
            {i18n.t("generic.or")}
          </Text>
          <AppButton
            disabled={actionInProgress}
            extraStyle={styles.extraStyleBtn}
            extraTextStyle={styles.extraStyleBtnText}
            onPress={() => askConfirmation("LOCK")}
          >
            {i18n.t("pages.access.lock").toUpperCase()}
          </AppButton>
        </View>
      </View>
    </View>
  );
}

const styleGen = (theme: MD3Theme) => StyleSheet.create({
  container: {
    //backgroundColor: theme.colors.secondary,
    borderColor:theme.colors.secondary,
    borderWidth:3,
    padding: 20,
    paddingBottom: 0,
    borderRadius: 20,
    alignItems: "center",
    gap: 20,
  },
  title: {
    fontSize: 25,
    textAlign: "center",
    fontFamily: "NotoSans-Bold",
  },
  actions: {
    width: "80%",
    marginTop: 0
  },
  actionsTitle: {
    fontSize: 20,
    textAlign: "center",
    fontFamily: "NotoSans-Light",
    marginBottom: 20,
  },
  actionsText: {
    fontSize: 20,
    textAlign: "center",
    fontFamily: "NotoSans-Light",
  },
  orText: {
    fontSize: 20,
    textAlign: "center",
    fontFamily: "NotoSans-Light",
    marginTop: 10,
    textTransform: "lowercase"
  },
  extraStyleBtn: {
    marginTop: 10,
    paddingVertical: 7,
  },
  extraStyleBtnText: { fontFamily: "NotoSans-Medium" },
  oiqia: {
    fontSize: 20,
    textAlign: "center",
    fontFamily: "NotoSans-Bold",
    color: theme.colors.primary,
  },
  laoding: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
